import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { AuthService } from '@core/services/entities/auth.service';
import { GetCompanyRequestDto } from '@domain/auth/dtos/get-company.request.dto';
import { GetCompanyResponseDto } from '@domain/auth/dtos/get-company.response.dto';
import { LoginRequestDto } from '@domain/auth/dtos/login.request.dto';
import { LoginResponseDto } from '@domain/auth/dtos/login.response.dto';
import { RecoveryPasswordRequestDto } from '@domain/auth/dtos/recovery-password.request.dto';
import { ResetPasswordRequestDto } from '@domain/auth/dtos/reset-password.request.dto';
import { ShowHoldingRequestDto } from '@domain/auth/dtos/show-holding.request.dto';
import { OrganizationHoldingResponseDto } from '@domain/organization-holding/dtos/organization-holding.response.dto';
import { TimerRequestDto } from '@domain/auth/dtos/timer.request.dto';
import { TimerResponseDto } from '@domain/auth/dtos/timer.response.dto';
import { VerifyMailRequestDto } from '@domain/auth/dtos/verify-mail.request.dto';
import { VerifyMailResponseDto } from '@domain/auth/dtos/verify-mail.response.dto';
import { AuthRepository } from '@domain/auth/repositories/auth.repository';
import { UserPersonResponseDto } from '@domain/user-person/dtos/user-person.response.dto';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthRepositoryService implements AuthRepository {
  constructor(private authService: AuthService) {}

  login(request: LoginRequestDto): Observable<ApiResponse<LoginResponseDto>> {
    return this.authService.login(request);
  }

  recoveryPassword(
    request: RecoveryPasswordRequestDto,
  ): Observable<ApiResponse<UserPersonResponseDto>> {
    return this.authService.recoveryPassword(request);
  }

  showHolding(
    request: ShowHoldingRequestDto,
  ): Observable<ApiResponse<OrganizationHoldingResponseDto>> {
    return this.authService.showHolding(request);
  }

  timer(request: TimerRequestDto): Observable<ApiResponse<TimerResponseDto>> {
    return this.authService.timer(request);
  }

  verifyMail(
    request: VerifyMailRequestDto,
  ): Observable<ApiResponse<VerifyMailResponseDto>> {
    return this.authService.verifyMail(request);
  }

  resetPassword(
    request: ResetPasswordRequestDto,
  ): Observable<ApiResponse<object>> {
    return this.authService.resetPassword(request);
  }

  getCompany(
    request: GetCompanyRequestDto,
  ): Observable<ApiResponse<GetCompanyResponseDto>> {
    return this.authService.getCompany(request);
  }
}
